import React, { useState } from 'react';
import InputBlock from '$/components/global/inputBlock';
import BixButton from '$/components/global/bixButton';
import './index.scss';
import { ClientAdminService } from '$/services';
import * as Bixby from '$/core';

interface IClientValidationProps {
  onValidityChange: (id: Bixby.Models.ClientDataSiteProvider) => void;
  currentCompanyId: string;
  clientDataSiteProvider: Bixby.Models.ClientDataSiteProvider;
}

const ClientValidation: React.FC<IClientValidationProps> = ({
  onValidityChange,
  clientDataSiteProvider,
  currentCompanyId,
}) => {
  const [idInput, setIdInput] = useState(undefined as string | undefined);
  const [error, setError] = useState(undefined as string | undefined);
  const [isLoading, setIsLoading] = useState(false);

  const validateClientDataSiteProvider = async () => {
    if (!idInput) return;
    try {
      setIsLoading(true);
      const result = await ClientAdminService.validateClientDataSiteProvider(idInput, currentCompanyId);
      onValidityChange(result);
      setError(undefined);
    } catch (err: any) {
      onValidityChange({} as Bixby.Models.ClientDataSiteProvider);
      const message =
        err && err.response && err.response.data && err.response.data.error
          ? err.response.data.error
          : 'An unknown error occurred.';
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClearClient = () => {
    onValidityChange({} as Bixby.Models.ClientDataSiteProvider);
  };

  return (
    <div className="client-id-contain">
      <InputBlock title="Client Identifier" required hasError={!!error}>
        <div className="grid">
          {!!clientDataSiteProvider?.client_Name && (
            <>
              <input readOnly value={`${idInput} - ${clientDataSiteProvider.client_Name}`} />
              <BixButton type="button" onClick={handleClearClient}>
                Clear
              </BixButton>
            </>
          )}
          {!clientDataSiteProvider?.client_Name && (
            <>
              <input onChange={e => setIdInput(e.target.value)} />
              <BixButton
                type="button"
                useLoading
                isLoading={isLoading}
                disabled={!idInput || isLoading}
                onClick={validateClientDataSiteProvider}>
                Validate
              </BixButton>
            </>
          )}
        </div>
        {error && <p className="error">{error}</p>}
      </InputBlock>
    </div>
  );
};

export default ClientValidation;
